import dynamic from "next/dynamic";
import { useEffect } from "react";
import useRoute from "./_hooks/CSRHooks/useRoute";

const Articles = dynamic(() => import('./Components/Article/Articles'));
const Category = dynamic(() => import('./Components/CategoryComponent/Category'));
const CategoryWrapper = dynamic(() => import('./Components/CategoryComponent/CategoryWrapper'));
const LandingPage = dynamic(() => import('./Components/LandingPages/LandingPage'));


const RouteWrapper = (props) => {
    const {
        exactRoute,
        data,
    } = props;

    const {data: routeData, route, loading, setData, setRoute} = useRoute(data, exactRoute);

    useEffect(() => {
        setData(data);
        setRoute(exactRoute);
    }, [data])
    
    return (
        <>
            {route == 'category' && (
                <>
                    <CategoryWrapper
                        category={{
                            ...routeData,
                            exactRoute
                        }}
                    >
                        <Category
                            categoryData={{
                                template_page_settings: routeData.template_page_settings,
                                long_term: routeData.long_term
                            }}
                            loading={loading}
                        />
                    </CategoryWrapper>
                </>
            )}

            {route == 'location' && (
                <>
                    <LandingPage loading={loading} {...routeData}/> 
                </>
            )}

            {route == 'article' && (
                <>
                    <Articles loading={loading} props={routeData} />
                </>
            )}
        </>
    )
}

export default RouteWrapper